
	import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';

	@Component
	export default class Modal extends Vue {
		@Prop() public stores!: any;

		private chosenStore: any;

		public created(): void {
			this.chosenStore = this.stores[0];
		}

		private storeChosen() {
			this.$emit('storeChosen', this.chosenStore);
		}
	}
